module.exports = __webpack_public_path__ + "static/media/dressRoom3.e54f36db.png";